/* eslint-disable complexity */
import deepClone from 'lodash/cloneDeep';

import { ResponseSubscriptionType } from '@r1-frontend/api-domru/api-tariffs/v1/tariffs/[salePackageId]/subscriptions';

import { InferValueTypes } from '@r1-frontend/shared/types/Redux';

import * as actionCreators from './actions';
import { initialState, TFullBuyData } from './initialState';

export const actionTypes = {
    INITIALIZED: '@full-buy/INITIALIZED',
    SET_DISPLAY_TARIFF_LINE_STATE: '@full-buy/SET_DISPLAY_TARIFF_LINE_STATE',
    SET_LOADER_SHOWN_FLAG: '@full-buy/SET_LOADER_SHOWN_FLAG',

    SET_TARIFFS: '@full-buy/SET_TARIFFS',
    UpdateTariffConnectionCost: '@full-buy/tariff/connectionCost/update',
    SetConnectionCostForCottage: '@full-buy/set/connectionCost',
    SetSubscriptions: '@full-buy/set/subscriptions',
    SetBundleOfSubscriptions: '@full-buy/set/subscriptionsBundle',
    SelectSubscription: '@full-buy/select/subscription',
    UnSelectSubscription: '@full-buy/unselect/subscription',

    SetCalculatedSalePackageId: '@full-buy/salePackageId/set',
    SetAddressData: '@full-buy/address/set',
    SetRequestCreatingStatus: '@full-buy/creatingRequestStatus/set',

    SET_TARIFF_LINE_ALIAS: '@full-buy/SET_TARIFF_LINE_ALIAS',
    SET_TARIFF_FILTERS: '@full-buy/SET_TARIFF_FILTERS',
    SelectTariff: '@full-buy/select/tariff',
    SET_PROMO_CODE: '@full-buy/SET_PROMO_CODE',
    SET_AGREEMENT_DATA: '@full-buy/SET_AGREEMENT_DATA',
    SET_CURRENT_STAGE: '@full-buy/SET_CURRENT_STAGE',
    RESET_FULLBUY: '@full-buy/RESET_FULLBUY',

    SET_FLOW: '@full-buy/SET_FLOW',
    SET_CURRENT_STEP: '@full-buy/SET_CURRENT_STEP',
    SET_PREV_STEP: '@full-buy/SET_PREV_STEP',

    ToggleBackgroundLoading: '@full-buy/loading/background/toggle',
} as const;

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

// eslint-disable-next-line default-param-last
export const fullBuyReducer = (state: TFullBuyData = initialState, action: TActions): TFullBuyData => {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (action.type) {
        case actionTypes.ToggleBackgroundLoading: {
            return {
                ...state,
                _backgroundLoading: action.payload,
            };
        }
        // Данные
        case actionTypes.SET_TARIFFS: {
            return {
                ...state,
                tariffs: action.payload,
            };
        }
        case actionTypes.UpdateTariffConnectionCost: {
            const selectedTariff = state.selectedTariff;

            if (selectedTariff !== null) {
                const tariffs = deepClone(state.tariffs).map(tariff => {
                    if (
                        ('salePackageId' in selectedTariff && tariff.sale_package_id === selectedTariff.salePackageId) ||
                        (
                            'monoTariff' in selectedTariff && 'tariffNameAlias' in selectedTariff &&
                            tariff.isMono === selectedTariff.monoTariff && tariff.alias === selectedTariff.tariffNameAlias
                        )
                    ) {
                        tariff.connectionPrice.final = action.payload.newPrice;
                    }
                    return tariff;
                });

                return {
                    ...state,
                    tariffs: tariffs,
                };
            } else {
                return { ...state };
            }

        }
        case actionTypes.SET_DISPLAY_TARIFF_LINE_STATE: {
            return {
                ...state,
                _displayTariffLine: action.payload.displayState,
            };
        }
        case actionTypes.SetSubscriptions: {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    [action.payload.tariffId]: {
                        oneOf: action.payload.subscriptionList.filter(s => s.type === ResponseSubscriptionType.oneOf).map(s => s.serviceId),
                        items: action.payload.subscriptionList,
                    },
                },
            };
        }
        case actionTypes.SetBundleOfSubscriptions: {
            return {
                ...state,
                subscriptions: action.payload.bundle,
            };
        }
        case actionTypes.SelectSubscription: {
            return {
                ...state,
                selectedSubscriptions: [...state.selectedSubscriptions, action.payload.subscriptionId],
            };
        }
        case actionTypes.SetAddressData: {
            return {
                ...state,
                selectedAddress: action.payload.selectedAddress,
            };
        }
        case actionTypes.UnSelectSubscription: {
            return {
                ...state,
                selectedSubscriptions: [...state.selectedSubscriptions.filter(s => s !== action.payload.subscriptionId)],
            };
        }
        case actionTypes.SetCalculatedSalePackageId: {
            return {
                ...state,
                calculatedSalePackageId: action.payload.salePackageId,
            };
        }
        case actionTypes.SET_TARIFF_LINE_ALIAS: {
            return {
                ...state,
                tariffLineAlias: state.tariffLineAlias === action.payload ? state.tariffLineAlias : action.payload,
            };
        }
        // Текущая секция
        case actionTypes.SET_CURRENT_STEP: {
            return {
                ...state,
                stepIndex: action.payload,
            };
        }
        case actionTypes.SET_PREV_STEP: {
            return {
                ...state,
                prevStepIndex: action.payload,
            };
        }
        case actionTypes.SET_FLOW: {
            return {
                ...state,
                flow: action.payload.flow,
            };
        }
        // Выбранный тариф
        case actionTypes.SelectTariff: {
            return {
                ...state,
                selectedTariff: action.payload,
                selectedSubscriptions: [],
            };
        }
        // Договор
        case actionTypes.SET_AGREEMENT_DATA: {
            return {
                ...state,
                agreement: action.payload,
            };
        }
        // создание заявки на подключение
        case actionTypes.SetRequestCreatingStatus: {
            return {
                ...state,
                isRequestCreatingFailed: action.payload,
            };
        }
        // Фильтры
        case actionTypes.SET_TARIFF_FILTERS: {
            return {
                ...state,
                filters: action.payload,
            };
        }
        // Промокод
        case actionTypes.SET_PROMO_CODE: {
            return {
                ...state,
                promoCode: action.payload,
            };
        }
        // Состояние лоадера при загрузке тайм-слотов
        case actionTypes.SET_LOADER_SHOWN_FLAG: {
            return {
                ...state,
                isShownLoader: action.payload,
            };
        }
        // Общие
        case actionTypes.INITIALIZED: {
            return {
                ...state,
                _addressVerificationOnFirstStep: action.payload.isAddressVerificationOnFirstStep,
                initialized: action.payload.status,
            };
        }
        case actionTypes.RESET_FULLBUY: {
            return initialState;
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};
